import '../AreasOfFocus/areas-of-focus.scss'
import React, { useState } from 'react'

const AreasOfFocus = ({ provider }) => {
  const pronoun = provider && provider.gender ? (provider.gender.toLowerCase() === 'male' ? 'his' : 'her') : 'the'
  const [showAll, setShowAll] = useState(false);
  const shouldDisplayShowMore = provider.areaOfFocus.length > 5;

  const handleToggle = () => {
    setShowAll(!showAll);
  }
  

  return (
    provider.areaOfFocus && provider.areaOfFocus.length > 0
      ? <div className=''>

        <h4 className='provider-aof-header'>Areas of Focus</h4>
        <div className='provider-aof-list'>
          <ul>
            {provider.areaOfFocus.slice(0, showAll ? provider.areaOfFocus.length : 5).map((element, index) => (<li key={index}>{element}</li>))}
          </ul>
          <p>This may not be a complete list for Dr. {provider.lastName}. Please call {pronoun} office if you have questions.</p>
        </div>
         {shouldDisplayShowMore && (
          <div className="show-all-aof">
         <a className="clickable" onClick={handleToggle}>
              {showAll ? 'Show Less Areas of Focus' : 'Show All Areas of Focus'}
              <span className="dropdown-arrow" style={{ marginLeft: 3, verticalAlign: 'middle' }}>
                {showAll ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 19 18" fill="none">
                    <path d="M6.0575 11.625L9.5 8.38006L12.9425 11.625L14 10.626L9.5 6.375L5 10.626L6.0575 11.625Z" fill="#0070AB"/>
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 19 18" fill="none">
                    <path d="M6.0575 6.375L9.5 9.61994L12.9425 6.375L14 7.37399L9.5 11.625L5 7.37399L6.0575 6.375Z" fill="#0070AB"/>
                  </svg>
                )}
              </span>
            </a>
         </div>
        )}
        <div className='flex justify-center'>
          <div className='drawer-divider' />
        </div>
      </div> : null
  )
}

export default AreasOfFocus
